export default __webpack_public_path__ + "static/media/hht2_Intonation_10.4fbf64e7.png";